module.exports = __webpack_public_path__ + "img/67_28.0fa1c960.png";